import { firebaseDb } from 'modules/firebase'


export const COUNTER_VALUE_RECEIVED = 'COUNTER_VALUE_RECEIVED'

export default (state = 0, { type, payload }) => {
  switch (type) {
    case COUNTER_VALUE_RECEIVED:
      return payload

    default:
      return state
  }
}

let counterRef

export const loadCounter = accountId => {
  if (counterRef) {
    counterRef.off()
  }

  return dispatch => {
    const today = new Date()
    const counterPath = `/counter/${accountId}/${today.getFullYear()}/${today.getMonth() + 1}`
    counterRef = firebaseDb.ref(counterPath)
    counterRef.on('value', snap => {
      const counterValue = snap.val()
      dispatch({
        type: COUNTER_VALUE_RECEIVED,
        payload: counterValue ? parseInt(counterValue, 10) : 0,
      })
    })
  }

}

export const getCounterValue = state => state.counter



// WEBPACK FOOTER //
// ./src/modules/counter/index.js